import React from 'react';
import Header from '../components/header2';
import Footer from '../components/footer';
//import Whatsapp from '../components/whatsapp';
import Snackbar from '../components/snackbar';


class Layout extends React.Component {
  state = {
    userName: this.props.data.userName,
    lastName: this.props.data.lastName
  }

  render() {

    return (
      <>
        <div className="relative">

          <Header userName={this.props.data.userName} lastName={this.props.data.lastName} logged={this.props.data.logged} handleLogout={this.props.handleLogout} />
          <Snackbar />
          <main>
            {this.props.children}
          </main>
          {/*
          <Whatsapp />
          */}
          <Footer />
        </div>
      </>
    )
  }
}

export default Layout;
